@if (showCameraSelect) {
  <div class="camera-select__wrapper [ w-full m-0 flex align-center border-0 ] [ index-overlay relative ]">
    @if (cameraDevices) {
      <dcr-select class="camera-select [ w-full h-full p-i-xs ]" [value]="selectedDeviceId" (change)="onDeviceSelectChange($event)">
        @if (!cameraDevices?.length) {
          <dcr-select-option value="" label="Geen camera's gevonden"></dcr-select-option>
        }
        @for (device of cameraDevices; track device) {
          <dcr-select-option
            [selected]="selectedDeviceId === device.deviceId"
            [value]="device.deviceId"
            [label]="device.label"
          ></dcr-select-option>
        }
      </dcr-select>
    } @else {
      <div class="[ p-b-2xs p-i-xs ]">Camera's zoeken, even geduld...</div>
    }
  </div>
}
<div class="camera-container [ relative w-full h-full ]">
  @if (cameraError) {
    <div class="[ flex flex-column h-full justify-center ]">
      <div class="[ flex ]">
        <svg class="[ w-full max-w-2/4 m-auto fill-background ]" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <path
            d="M9.56 8l-2-2-4.15-4.14L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.55-.18L19.73 21l1.41-1.41-8.86-8.86L9.56 8zM5 16V8h1.73l8 8H5zm10-8v2.61l6 6V6.5l-4 4V7c0-.55-.45-1-1-1h-5.61l2 2H15z"
          />
        </svg>
      </div>
      <p class="[ p-i-m text-background text-center weight-bold ]">
        {{ cameraError }}
      </p>
    </div>
  } @else {
    <video
      #camera
      [class.camera--valid]="!!scanResult"
      [class.camera--mirror]="mirrorCamera"
      class="camera [ h-full w-full ]"
      autoplay
      playsinline
      muted
      data-cy="video-camera"
    ></video>
    @if (showOverlay && !isLoading) {
      <div class="camera-overlay">
        <div class="camera-overlay-square"></div>
      </div>
    }
    @if (isLoading) {
      <div class="[ absolute top-1/2 left-1/2 transform -translate-1/2 ] [ title-medium on-primary ]">De camera word gestart...</div>
    }
  }
</div>
